import { GlobalResponseObject } from  "../../../common";;
import { HourWiseDowntimeModel } from "./hour-wise-downtime.model";
export class LineDowntimeResponse extends GlobalResponseObject{
    data?: HourWiseDowntimeModel[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: HourWiseDowntimeModel[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

